<template>
  <div id="photo" class="container-80 uploading">
    <div class="row justify-content-center">
      <!-- 进度条部分 -->
      <div class="col-12">
        <el-steps :active="active" finish-status="success" v-show="stepshow">
          <el-step :title="$t('Album.uploadImage.Selectpicture')"></el-step>
          <el-step :title="$t('Album.uploadImage.uploading')"></el-step>
          <el-step :title="$t('Album.uploadImage.complete')"></el-step>
        </el-steps>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12" style="text-align: right">
            <el-button type="primary" @click="uploadProcess()" :loading="submitBtn">{{$t('Album.uploadImage.Uploadandsave')}}</el-button>
          </div>
        </div>
        <div v-if="errorList.length > 0" style="color: red; word-break: break-all">
          {{$t('Album.uploadImage.the')}}{{ errorList.join() }}{{$t('Album.uploadImage.failed')}}
        </div>
        <h2 class="section-title">{{ sectionTitle }}</h2>
        <div class="row">
          <!-- 选择图片部分 -->
          <div class="col-12 col-lg-9" v-if="selectblock == 1">
            <!-- <uploadimg></uploadimg> -->
            <div class="photo-uploader pt-1">
              <div class="photo-upload">
                <!--  <div class="upload-dragger">-->
                <!-- <div class="upload-container">-->
                <el-upload class="upload-demo" drag action="fackaction" :show-file-list="false"
                  :before-upload="beforeupload" :on-change="onchangeupload" :http-request="fupload" multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    {{$t('Album.uploadImage.filehere')}}，{{$t('Album.uploadImage.or')}}<em>{{$t('Album.uploadImage.ClickuploadFile')}}</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">
                    {{$t('Album.uploadImage.uploadfiles')}}
                  </div>
                </el-upload>

                <!-- <div class="upload-text">
                      <h4><a href="">點擊上傳</a></h4>
                      或將相片拖曳到此處
                    </div> -->
                <!--</div>-->
                <!--</div>-->
                <input type="file" name="file" class="upload-input" />
              </div>
              <div class="row">
                <!-- <div class="col-12">
                  （每頁顯示數量跟瀏覽相簿時每頁顯示的相片數量一樣）
                </div> -->
                <div class="album-card card m-0 col-lg-2 col-6 b" v-for="image in imgList" :key="image.name">
                  <div class="album-block">
                    <div class="album-thumbnail">
                      <div class="album-responsive">
                        <div class="album-sizer">
                          <div class="album-image" :style="{
                            backgroundImage: 'url(' + image.src + ')',
                          }"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="album-info p-3">
                    <div class="album-title mb-2" :title="image.name">
                      {{ image.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="upload-tip mt-3">
                <ul>
                  <li v-if="this.imgl.length > 12">
                    <el-alert :title="`${$t('Album.uploadImage.Waitfor')}${this.imgl.length - 12}${$t('Album.uploadImage.pictures')}`" type="success" center show-icon
                      :description="$t('Album.uploadImage.pleasefeel')" effect="dark">
                    </el-alert>
                  </li>
                  <li>
                    {{$t('Album.uploadImage.use')}}
                    <a href="https://www.google.com/chrome/" target="_blank">{{$t('Album.uploadImage.Google')}}</a>{{$t('Album.uploadImage.upload')}}
                  </li>
                  <li>
                    {{$t('Album.uploadImage.and')}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 进度条 -->
          <div class="col-lg-9 col-12 mt-3 pr-4" v-else-if="selectblock == 2">
            <div class="row mb-4">
              <div class="col-12 pt-2">
                <label for="upload-label">{{$t('Album.uploadImage.Uploadprogress')}}</label>
                <el-progress :text-inside="true" :stroke-width="24" :percentage="AlbumInfo.percentage"
                  status="success"></el-progress>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <i class="fa fa-images fa-fw mr-1"></i>{{$t('Album.uploadImage.Photocount')}}:
                {{ AlbumInfo.Total }} {{$t('Album.uploadImage.piece')}}
              </div>
              <div class="col-6">
                <i class="fa fa-upload fa-fw mr-1"></i>{{$t('Album.uploadImage.Uploadedphoto')}}:
                {{ AlbumInfo.uploadfinsh }} {{$t('Album.uploadImage.piece')}}
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <i class="fa fa-thumbs-up fa-fw mr-1"></i>{{$t('Album.uploadImage.Currentrate')}}:
                <b id="dangqiansulv">0 KB</b>
              </div>
              <div class="col-6">
                <i class="fa fa-hourglass-half fa-fw mr-1"></i>{{$t('Album.uploadImage.Timespent')}}:
                {{ AlbumInfo.usetime }}
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <i class="fa fa-clock fa-fw mr-1"></i>{{$t('Album.uploadImage.Estimatedtime')}}:
                <b id="yjwcsj"></b>
              </div>
              <div class="col-6">
                <i class="fa fa-check-circle fa-fw mr-1"></i>{{$t('Album.uploadImage.uploadings')}}:
                {{ AlbumInfo.uploadimageName }}
              </div>
            </div>
          </div>
          <!-- 上传成功至mini后显示的页面 -->
          <div class="col-lg-9 col-12" v-else-if="selectblock == 3">
            <!-- 增加相片  -->
            <div class="row">
              <div class="section-group col">
                <el-button type="primary" @click="addImage()" icon="fa fa-plus fa-fw fa-sm mr-1">{{$t('Album.uploadImage.Addphoto')}}</el-button>
                <el-button v-if="sectionTitle === $t('Album.uploadImage.EditsectionTitle')" type="primary" @click="deletePage"
                  :loading="deletePageLoading">{{$t('Album.uploadImage.Deleteentire')}}</el-button>
                <el-button v-if="sectionTitle === $t('Album.uploadImage.EditsectionTitle')" type="primary" @click="deleteAll"
                  :loading="deleteAllLoading">{{$t('Album.uploadImage.Deleteall')}}</el-button>
                <!-- <el-button
                  type="primary"
                  @click="deleteMinioAll()"
                  icon="fa fa-trash-alt fa-fw fa-sm mr-1"
                  >刪除所有相片</el-button
                > -->
              </div>
              <!-- <div class="section-group col-6" style="text-align: right">
                <el-button
                  type="primary"
                  icon="fa fa-sort-alpha-down fa-fw fa-sm mr-1"
                  >按相片名稱排序</el-button
                >
                <el-button
                  type="primary"
                  icon="fa fa-sort-amount-down fa-fw fa-sm mr-1"
                  >按拍攝時間順序</el-button
                >
                <el-button
                  type="primary"
                  icon="fa fa-sort-amount-down fa-fw fa-sm mr-1"
                  >按上載時間順序</el-button
                >
              </div> -->
            </div>
            <!-- ./增加相片 -->
            <div class="row">
              <!-- <div class="col-12">
                （每頁顯示數量跟瀏覽相簿時每頁顯示的相片數量一樣）
              </div> -->

              <div v-show="pageData.length > 0" class="album-card card m-0 col-lg-2 col-6 a" v-for="image in pageData.filter(
                (c) => getFileName(c.src) !== 'AlbumPoster.jpg'
              )" :key="image.name">
                <div class="album-block">
                  <div class="album-thumbnail">
                    <div class="album-responsive">
                      <div class="album-sizer">
                        <div class="album-image" :style="{
                          backgroundImage: 'url(' + image.src + ')',
                        }"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="album-info p-3">
                  <!-- <div class="album-title mb-2" :title="image.name">
                    {{ image.name }}
                  </div>
                  <div class="time">2020/07/06 06:14:53</div> -->
                  <div class="photo-edit-bar">
                    <div class="photo-details">
                      <div class="title">
                        {{ image.name }}
                      </div>
                      <div class="time">
                        {{ dateFormat(image.time) }} &nbsp;&nbsp;
                        <i @click="deleteMinio(image.name)" class="el-icon-delete"></i>
                      </div>
                    </div>
                    <!-- <div class="photo-keywords">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="相片關鍵字"
                      />
                    </div> -->
                  </div>
                </div>
              </div>

              <div v-show="pageData.length <= 0 && photoList.length > 0" class="album-card card m-0 col-2"
                v-for="photo in photoList" :key="photo.id">
                <div class="album-block">
                  <div class="album-thumbnail">
                    <div class="album-responsive">
                      <div class="album-sizer">
                        <div class="album-image" :style="{
                          backgroundImage: 'url(' + photo.imageUrl_S + ')',
                        }"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="album-info p-3">
                  <!-- <div class="album-title mb-2" :title="image.name">
                    {{ image.name }}
                  </div>
                  <div class="time">2020/07/06 06:14:53</div> -->
                  <div class="photo-edit-bar">
                    <div class="photo-details">
                      <div class="title">
                        {{ photo.sgL_PG_LPhotoName }}
                      </div>
                      <div class="time">
                        {{ photo.sgL_PG_LShootTimerI }} &nbsp;&nbsp;
                        <i @click="deletePhoto(photo.id)" class="el-icon-delete"></i>
                      </div>
                    </div>
                    <!-- <div class="photo-keywords">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="相片關鍵字"
                      />
                    </div> -->
                  </div>
                </div>
              </div>

              <!-- <div class="col-2 py-1" v-for="data in pageData" :key="data.name">
                <div class="photo-card card">
                  <img :src="data.src" />
                  <div class="photo-edit-bar">
                    <div class="photo-details">
                      <div class="title">{{ data.name }}</div>
                      <div class="time">{{ data.time }}</div>
                    </div>
                    <div class="interaction-control">
                      <a
                        href=""
                        class="interaction-icon delete"
                        title="移除相片"
                        ><i class="fa fa-trash-alt fa-fw"></i
                      ></a>
                    </div>
                    <div class="photo-keywords">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="相片關鍵字"
                      />
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- 頁碼 -->
              <div class="col-12 my-5">
                <pagination v-if="getPageShow" :currentPage="pageParams.currentPage" :total="pageParams.total"
                  :limit="pageParams.limit" :small="true" @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange" />
              </div>
              <!-- /.頁碼 -->
            </div>
          </div>
          <!-- 相簿信息部分 -->
          <div class="col-lg-3 col-12">
            <div class="card card-primary">
              <div class="card-body">
                <div class="album-setting">
                  <label for="album-image">
                    <i style="color: red">*</i>{{$t('Album.uploadImage.Compactphoto')}}</label>

                  <!-- Album Image -->
                  <div class="album-thumbnail">
                    <div class="album-responsive mb-2">
                      <el-upload class="avatar-uploader" action="" :show-file-list="false" :auto-upload="false"
                        :on-change="changeUpload">
                        <img v-if="albumModel.imageUrl" :src="albumModel.imageUrl" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <ImgCropperVue class="ImgCropperVue" ref="cro" @cropperConfirm="cropperConfirm"
                        :props_autoCropWidth="450" :props_autoCropHeight="450" :props_full="false" :props_original="true"
                        :props_centerBox="true" :props_high="false" :props_fixed="true" :props_info="true"
                        :props_canMove="true" :props_canScale="true">
                      </ImgCropperVue>
                    </div>
                  </div>
                  <!-- /.Album Image -->

                  <el-form :model="albumModel" :rules="albumRule" ref="albumModel">
                    <el-form-item :label="$t('Album.uploadImage.title')" prop="title">
                      <el-input v-model="albumModel.title"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Album.uploadImage.description')">
                      <el-input type="textarea" v-model="albumModel.description"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Album.uploadImage.keyword')">
                      <el-input v-model="albumModel.keyword" :placeholder="$t('Album.uploadImage.keywordplaceholder')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Album.uploadImage.type')" prop="type">
                      <el-select v-model="albumModel.type">
                        <el-option v-for="albumtype in typelist" :key="albumtype.id" :label="albumtype.sgL_NewName"
                          :value="albumtype.id"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Album.uploadImage.time')" prop="time">
                      <el-date-picker type="date" value-format="yyyy-MM-dd" v-model="albumModel.time"
                        :picker-options="pickerOptions">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('Album.uploadImage.active')">
                      <el-radio v-model="albumModel.active" :value="0" label="0">{{$t('Album.uploadImage.notnull')}}</el-radio>
                      <el-radio v-model="albumModel.active" :value="1" label="1">{{$t('Album.uploadImage.date')}}</el-radio>
                    </el-form-item>
                    <el-form-item :label="$t('Album.uploadImage.activeDate')" v-show="albumModel.active == 1">
                      <el-date-picker value-format="yyyy-MM-dd" @change="GetEventList(albumModel.activeDate, true)"
                        type="date" v-model="albumModel.activeDate" :placeholder="$t('Album.uploadImage.activeplaceholder')"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('Album.uploadImage.activeId')" v-show="albumModel.active == 1">
                      <el-select v-model="albumModel.activeId">
                        <el-option v-for="active in activeList" :key="active.id" :value="active.id"
                          :label="active.sgL_Title"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Album.uploadImage.set')">
                      <el-select v-model="albumModel.set">
                        <el-option :label="$t('Album.uploadImage.open')" :value="true"></el-option>
                        <!-- <el-option
                          label="不公開，只有得知影片連結的人才能觀看"
                          value="不公開，只有得知影片連結的人才能觀看"
                        ></el-option> -->
                        <el-option :label="$t('Album.uploadImage.notopen')" :value="false"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="EXIF">
                      <el-tooltip placement="top">
                        <div slot="content">
                          {{$t('Album.uploadImage.ShareEXIF')}}<br />{{$t('Album.uploadImage.Include')}}
                        </div>
                        <i class="fa fa-question-circle ml-1"></i>
                      </el-tooltip>
                      <el-radio v-model="albumModel.EXIF" :label="true">{{$t('Album.uploadImage.open')}}</el-radio>
                      <el-radio v-model="albumModel.EXIF" :label="false">{{$t('Album.uploadImage.hide')}}</el-radio>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
              <!-- /.card-body -->
            </div>
          </div>

          <!-- /.card -->
        </div>
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->
    <div class="row justify-content-center">
      <div class="col-12">
        <!-- <a href="#" class="btn btn-secondary">取消</a> -->
      </div>
    </div>
    <!-- Form -->
    <el-dialog :title="$t('Album.uploadImage.dialogFormVisible')" :visible.sync="dialogFormVisible">
      <div style="color: red; margin-bottom: 10px">
        {{$t('Album.uploadImage.dtl')}}
      </div>
      <el-radio-group v-model="filenameModel">
        <el-radio-button v-for="name in fileNameList" :key="name" :label="name">{{ format(name) }}</el-radio-button>
      </el-radio-group>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="deleteTempMinio" :loading="deleteTempLoading">{{$t('Album.uploadImage.del')}}</el-button>
        <el-button @click="cancle()">{{$t('Album.uploadImage.cancle')}}</el-button>
        <el-button type="primary" @click="submit()">{{$t('Album.uploadImage.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { v4 as uuidv4 } from "uuid";
import pagination from "../common/Page";
import base from "./../../api/httpApi/base";
import ImgCropperVue from "../common/ImgCropper.vue";
import socket from "@/assets/js/websocketTools";
import moment from "moment";
import { nanoid } from "nanoid";
import { clearInterval } from "timers";

export default {
  data() {
    return {
      deletePageLoading: false,
      deleteAllLoading: false,
      uploadFileDateList: [],
      noJisuanDateList: [],
      deleteTempLoading: false,
      errorList: [],
      notify: null,
      socketInfo: {
        beginUploadTime: "",
        size: 0,
        rate: "",
        requestId: nanoid(),
      },
      UploadTime: null,
      totalSize : 0,
      totalTime : 0,
      saveLoading: false,
      pageTitle: this.$t('Album.uploadImage.Uploaddomtitle'),
      sectionTitle: this.$t('Album.uploadImage.sectionTitle'),
      currentAuthorId: 0,
      typelist: null,
      UploadImageCountSizeKB: 0, //总上传大小
      CommintUploadSizeKB: 0, //已上传大小
      active: 1,
      activeList: null,
      ThisSulv: null, //3秒抓取一下速率
      submitBtn: false, //保存按钮默认禁用，上传完至minio再放开
      timeData: null, //上传计时器
      albumModel: {
        set: "",
        EXIF: true,
        time: null,
        type: null,
        activeDate: null,
        active: "0",
        activeId: null,
        activename: null,
        keyword: null,
        description: null,
        title: "",
        imageUrl: "", //上传后的图片地址
      },
      albumData: null, //编辑加载的ablum实体
      paramsData: null,
      albumRule: {
        title: [{ required: true, message: this.$t('Album.uploadImage.albumRule.title'), trigger: "blur" }],
        time: [{ required: true, message: this.$t('Album.uploadImage.albumRule.time'), trigger: "changes" }],
        type: [
          { required: true, message: this.$t('Album.uploadImage.albumRule.type'), trigger: "change" },
        ],
      },
      albumId: null,
      uploadId: "", //上传后的图片id，用于存储到数据库
      imageUploadUrl: `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=album`,
      minioClient: null,
      imgList: [], //用于显示图片
      imageCount: 0,
      selectblock: 1, //控制显示内容
      stepshow: true, //进度条显示
      status: "Create",
      buckettime: null, //文件夹名
      bases: null,
      customer: null,
      customerModel: null,
      fileNameList: [],
      filenameModel: "",
      imgl: [], //上传至minio的list
      AlbumInfo: {
        Total: 0,
        uploadfinsh: 0,
        finshTime: null,
        usetime: null,
        uploadimageName: "",
        percentage: 0,
        uploadSuccessfinsh: 0,
      },
      dialogFormVisible: false,
      //第三步 的数据结构
      dataList: [],
      pageData: [],
      photoList: [],
      //分页参数
      pageParams: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  watch: {
    imgl: {
      handler: function (newval, oldval) {
        if (this.imgl.length == 0) {
          this.selectblock = 3;
          this.active = 3;
          this.getDataList(true);
        }
      },
    },
    '$i18n.locale'(newValue,old) {
      if (this.sectionTitle == this.$t('Album.uploadImage.EditsectionTitle'))
        this.sectionTitle == this.$t('Album.uploadImage.EditsectionTitle')
      else
        this.sectionTitle = this.$t('Album.uploadImage.sectionTitle')
      if (this.pageTitle == this.$t('Album.uploadImage.Editdomtitle'))
        this.pageTitle == this.$t('Album.uploadImage.Editdomtitle')
      else
        this.pageTitle = this.$t('Album.uploadImage.Uploaddomtitle');
        this.albumRule.title[0].message = this.$t('Album.uploadImage.albumRule.title');
        this.albumRule.time[0].message = this.$t('Album.uploadImage.albumRule.time');
        this.albumRule.type[0].message = this.$t('Album.uploadImage.albumRule.type');
    },
    dataList: {
      handler: function (newval, oldval) { },
    },
    status: {
      handler: function (newval, oldval) {
        if (newval == "Update") {
          document.title = this.$t('Album.uploadImage.Editdomtitle');
          this.sectionTitle = this.$t('Album.uploadImage.EditsectionTitle');
        } else if (newval == "Create") {
          document.title = this.$t('Album.uploadImage.sectionTitle');
          this.sectionTitle = this.$t('Album.uploadImage.Uploaddomtitle');
        }
        this.pageTitle = document.title;
      },
    },
    "AlbumInfo.percentage": {
      handler: function (newval, oldval) {
        if (newval == 100) {
          document.title = this.pageTitle;
        } else {
          document.title = `(${newval})%${this.pageTitle}`;
        }
      },
    },
  },
  components: {
    pagination,
    ImgCropperVue,
  },
  async created() {
    this.$store.dispatch("updateCurrentIndex", 0);
    this.$route;
    this.$store.dispatch("getCommonTypeDesk", 70).then((res) => {
      this.typelist = res; //相簿類型
    });
    this.bases = base;
    this.customer = this.$store.getters.getcustomer;

    //#region 暂时为了测试写的
    // let userlist = [
    //   196572, 206283, 223772, 226985, 230379, 230713, 1, 126654, 3, 13522,
    //   126654, 203688, 206267, 230884,
    // ];
    // if (this.customer == null) {
    //   this.$router.push({
    //     name: "customerLogin",
    //     query: { redirect: this.$route.params.path },
    //   });
    //   return;
    // }
    //#endregion
    // if (userlist.indexOf(this.currentAuthorId) == -1) {
    //   this.$router.push({ name: "albumIndex" });
    // }
    this.currentAuthorId = this.customer.userId;

    //#region  编辑页面逻辑
    this.buckettime = Date.parse(new Date()) + "File"; //文件夹名
    this.initMinio();

    let params = this.$route.query;
    this.albumId = params.id;
    this.paramsData = params;
    if (params != null && params.tid == 3) {
      //判断是否加载编辑页面；
      this.status = "Update";
      await this.getAblumDtl(params.id);
      this.stepshow = false;
      this.selectblock = 3;
      this.active = 3;
      this.getCustomerModel();
      this.bucketExists();
    } else {
      this.getCustomerModel();
      this.bucketExists();
      this.getBucketFileList();
    }
    //#endregion
  },
  methods: {
    deletePage() {
      if (this.photoList && this.photoList.length > 0) {
        const ids = this.photoList.map((c) => c.id);
        let params = ids;
        this.deletePageLoading = true;
        this.$api.albumApi
          .delphotoPage(params)
          .then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: this.$t('message.operatesuccessfully'),
              });
              this.getAblumDtl(this.albumId);
            }
          })
          .catch()
          .then(() => {
            this.deletePageLoading = false;
          });
      }
    },
    deleteAll() {
      this.deleteAllLoading = true;
      let params = {
        id: this.albumId,
      };
      this.$api.albumApi
        .delphotoAll(params)
        .then((res) => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: this.$t('message.operatesuccessfully'),
            });
            this.getAblumDtl(this.albumId);
          }
        })
        .catch()
        .then(() => {
          this.deleteAllLoading = false;
        });
    },
    fupload(params) {
      switch (params.file.type) {
        case "image/jpeg":
          break;
        case "image/png":
          break;
        default:
          this.$message({
            type: "error",
            message: "請選擇jpg/png格式",
          });
          return;
      }
      //判断是否有重名文件
      if (!this.imgl) {
        this.imgl = [];
      }
      const sameName = this.imgl.filter(
        (c) => c.name.toLowerCase() === params.file.name.toLowerCase()
      );
      if (!this.pageData) {
        this.pageData = [];
      }
      const sameName2 = this.pageData.filter(
        (c) => c.name.toLowerCase() === params.file.name.toLowerCase()
      );
      if (!this.photoList) {
        this.photoList = [];
      }
      const sameName3 = this.photoList.filter(
        (c) =>
          c.sgL_PG_LPhotoName.toLowerCase() +
          c.sgL_PG_LPhotoOldExtensionName.toLowerCase() ===
          params.file.name.toLowerCase()
      );
      if (
        sameName.length === 0 &&
        sameName2.length === 0 &&
        sameName3.length === 0
      ) {
        this.imgl.push(params.file); //拿到所有文件
        if (this.imageCount < 12) {
          this.imageCount++;
          this.tobase64(params.file);
        }
      }
    },
    UpdateUploadCallBack(size) {
      size = parseFloat((size / 1024).toFixed(2));
      this.CommintUploadSizeKB += size; //已完成上传的kb数据
      this.uploadFileDateList.push({
        id: nanoid(),
        date: this.getNowTime(),
        size,
      });
    },
    //獲取當前登錄人用戶信息
    getCustomerModel() {
      let params = {
        Id: this.currentAuthorId,
      };
      this.$api.common.GetUserInfoById(params).then((res) => {
        if (res.data.success) {
          this.customerModel = res.data.result;
        }
      });
    },
    bytesToSize(bytes) {
      if (bytes === 0) return '0 KB';
      let k = 1000, // or 1024
        sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
      return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
    },
    getThisSulv() {
      var _this = this;
      const time = 10;
      this.ThisSulv = window.setInterval(function () {
        if (_this.uploadFileDateList.length === 0) {
          return;
        }
        let curTime = new Date();
        let jisuanList = _this.uploadFileDateList.filter(
          (c) =>
            Date.parse(c.date) < Date.parse(curTime) &&
            _this.noJisuanDateList.indexOf(c.id) === -1
        );
        let size = 0;
        if (jisuanList.length > 0) {
          let allSize = 0;
          jisuanList.forEach((item) => {
            allSize += item.size;
            _this.noJisuanDateList.push(item.id);
          });
          size = (allSize / time).toFixed(2);
          // console.log("上传文件大小:", size, jisuanList.length);
        }
        if (size > 1024) {
          _this.socketInfo.rate =
            parseFloat((size / 1024).toFixed(2)) + " MB/s";
          // $("#dangqiansulv").text(
          //   parseFloat((size / 1024).toFixed(2)) + " MB/s"
          // );
        } else {
          _this.socketInfo.rate = size + " KB/s";
          // $("#dangqiansulv").text(size + " KB/s");
        }
        _this.sendWebSocket();

        //剩余待上传的数据KB量
        var seng = parseFloat(
          (_this.UploadImageCountSizeKB - _this.CommintUploadSizeKB).toFixed(2)
        );
        //剩余的数据量除当前上传速度 等于剩余秒
        var sencoent = parseInt(seng / (size === 0 ? 1 : size));
        var addSeconds = new Date(
          curTime.setSeconds(curTime.getSeconds() + sencoent)
        );
        //预计时间
        $("#yjwcsj").text(_this.formatTime(addSeconds, "yyyy-MM-dd hh:mm:ss"));
      }, time * 1000);
    },
    formatTime(date, fmt) {
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },
    async sendWebSocket() {
      let msg = {
        requestId: sessionStorage.getItem("websocketId"),
        userName: this.loginUser.displayName,
        number: this.AlbumInfo.Total,
        size: this.UploadImageCountSizeKB,
        date: this.socketInfo.beginUploadTime,
        rate: this.socketInfo.rate,
        isMobile: this.checkIsMobile(),
        ps: this.AlbumInfo.percentage,
        time: this.AlbumInfo.usetime,
      };
      // socket.websocketsend({
      //   MessageType: "uploadImage",
      //   Content: JSON.stringify(msg),
      // });
      const params = {
        MessageType: "uploadImage",
        Content: JSON.stringify(msg),
      }
      const { data: reslut } = await this.$api.common.SetredisCache(params);
    },
    //上传至minio
    async uploadProcess() {
      this.submitBtn = true;
      try {
        //保存的判断
        let isShowMsg = false;
        if (this.albumData != null && this.albumData.id > 0) {
          if (
            this.photoList.length === 0 &&
            this.pageData.length === 0 &&
            this.imgl.length === 0
          ) {
            isShowMsg = true;
          }
        } else {
          if (this.pageData.length === 0 && this.imgl.length === 0) {
            isShowMsg = true;
          }
        }
        if (isShowMsg) {
          this.$message({
            type: "warning",
            message: "請至少上傳一張相片",
          });
          return;
        }
        //判断是否上传封面图
        if (
          this.albumModel.imageUrl === null ||
          this.albumModel.imageUrl === ""
        ) {
          this.$message({
            type: "warning",
            message: "請上傳主圖",
          });
          return;
        }
        this.$refs["albumModel"].validate((valid) => {
          if (!valid) {
            this.$message({
              type: "error",
              message: "請填寫必填項",
            });
            return;
          }
        });

        window.clearInterval(this.timeData);
        this.timer();

        window.clearInterval(this.ThisSulv);
        this.getThisSulv();

        //驗證圖片空間
        var network = this.customerModel.sgL_SelfNetworkDisk; //MB
        var disk = parseInt(this.customerModel.sgL_NetworkDiskCapacity) * 1024; //GB
        var thisCountMb = (
          this.UploadImageCountSizeKB / 1024 +
          network
        ).toFixed(2);

        if (thisCountMb >= disk) {
          this.$message({
            type: "error",
            message: "上傳圖片空間不足，請聯繫管理員",
          });
          return;
        }

        //END驗證圖片空間
        this.socketInfo.beginUploadTime = moment().format("MM/DD HH:mm:ss");
        this.socketInfo.size = 0;
        this.active = 2;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        if (this.imgl.length > 0) {
          this.selectblock = 2; //显示进度条
        }
        this.AlbumInfo.Total = this.imgl.length;
        this.imgl.forEach((res, i) => {
          this.UploadImageCountSizeKB += res["size"];
        });
        this.UploadImageCountSizeKB = (
          this.UploadImageCountSizeKB / 1024
        ).toFixed(2);
        this.CommintUploadSizeKB = 0; //重新点击上传吧，之前的上传记录清空
        this.AlbumInfo.uploadfinsh = 0;
        this.AlbumInfo.uploadSuccessfinsh = 0;
        this.uploadFileDateList = [];
        this.noJisuanDateList = [];
        let count = 0;
        if (!this.buckettime || this.buckettime === "") {
          this.$message({
            type: "error",
            message: "上傳文件夾為空，將自動重新加載頁面",
          });
          setTimeout(() => {
            window.location = window.location;
          }, 1500);
          return;
        }
        this.sendWebSocket();
        this.errorList = [];
        if (this.imgl.length > 0) {
          this.totalTime = 0;
          this.totalSize = 0;
          const imgCopy = [...this.imgl];
          for (let i = 0; i < imgCopy.length; i++) {
            try {
              let isSuccess = await this.uploadImage(imgCopy[i], i);
              if (!isSuccess) {
                this.errorList.push(i + 1);
              } else {
                this.AlbumInfo.uploadSuccessfinsh += 1;
              }
            } catch (error) {
              console.log("upload error", error);
            }
          }
        } else {
          this.createAlbum("albumModel");
        }
        window.clearInterval(this.ThisSulv);
      } catch (error) {
        console.error(error);
      } finally {
        this.submitBtn = false;
      }
    },
    //获取当前时间
    getNowTime(isYMD) {
      var date = new Date();
      //年 getFullYear()：四位数字返回年份
      var year = date.getFullYear(); //getFullYear()代替getYear()
      //月 getMonth()：0 ~ 11
      var month = date.getMonth() + 1;
      //日 getDate()：(1 ~ 31)
      var day = date.getDate();
      //时 getHours()：(0 ~ 23)
      var hour = date.getHours();
      //分 getMinutes()： (0 ~ 59)
      var minute = date.getMinutes();
      //秒 getSeconds()：(0 ~ 59)
      var second = date.getSeconds();

      var time =
        year +
        "-" +
        this.addZero(month) +
        "-" +
        this.addZero(day) +
        " " +
        this.addZero(hour) +
        ":" +
        this.addZero(minute) +
        ":" +
        this.addZero(second);
      if (isYMD) {
        time = year + "-" + this.addZero(month) + "-" + this.addZero(day);
      }
      return time;
    },
    //小于10的拼接上0字符串
    addZero(s) {
      return s < 10 ? "0" + s : s;
    },
    checkIsMobile() {
      let sUserAgent = navigator.userAgent.toLowerCase();
      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          sUserAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    createAlbum(formName) {
      let isShowMsg = false;
      if (this.albumData != null && this.albumData.id > 0) {
        if (this.photoList.length === 0 && this.pageData.length === 0) {
          isShowMsg = true;
        }
      } else {
        if (this.pageData.length === 0) {
          isShowMsg = true;
        }
      }
      if (isShowMsg) {
        this.$message({
          type: "warning",
          message: "請至少上傳一張相片",
        });
        return;
      }
      this.errorList = [];
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //判断是否上传封面图
          if (
            this.albumModel.imageUrl === null ||
            this.albumModel.imageUrl === ""
          ) {
            this.$message({
              type: "warning",
              message: "請上傳主圖",
            });
            return;
          }
          this.submitBtn = true;
          let params = {
            sgL_Mem_Cid: this.currentAuthorId,
            sgL_PG_CName: this.albumModel.title,
            sgL_ImageId: 0,
            sgL_PG_CContent: this.albumModel.description,
            sgL_Keyword: this.albumModel.keyword,
            sgL_PG_CResourcesFolder: this.buckettime,
            sgL_PG_CMasterSort: this.albumModel.type,
            sgL_PG_CShowExif: this.albumModel.EXIF,
            sgL_PG_CShootTimer: this.albumModel.time,
            sgL_PG_CPublicshare: this.albumModel.set,
            sgL_PG_CGameID: this.albumModel.activeId,
            sgL_PG_CGameDate: this.albumModel.activeDate,
            SuccessCount: this.AlbumInfo.uploadSuccessfinsh,
            ImageCount: this.AlbumInfo.Total,
          };

          //console.log(params);
          //console.log(params.sgL_PG_CShootTimer);
          if (this.albumModel.active == "0") {
            params.sgL_PG_CGameID = "";
            params.sgL_PG_CGameDate = "";
          }
          if (this.albumData != null && this.albumData.id > 0) {
            //修改
            params.id = this.albumData.id;
            this.$api.albumApi
              .updateAlbum(params)
              .then((result) => {
                if (result.data.success) {
                  this.$message({
                    type: "success",
                    message: this.$t('message.operatesuccessfully'),
                  });
                  if (
                    this.albumData.sgL_Mem_Cid != this.loginUser.userId &&
                    this.loginUser.isAdmin
                  ) {
                    this.$router.push({
                      name: "albumviewPhotostream",
                      query: {
                        id: this.$route.query.id,
                      },
                    });
                  } else {
                    this.$router.push({ name: "customerPublish" });
                  }
                } else {
                  this.$message({
                    type: "error",
                    message: this.$t('message.operationfailure'),
                  });
                }
              })
              .catch((err) => { })
              .then(() => {
                this.saveLoading = false;
              });
          } else {
            this.$api.albumApi
              .createAlbum(params)
              .then((res) => {
                if (res.data.success) {
                  this.$message({
                    type: "success",
                    message: this.$t('message.operatesuccessfully'),
                  });
                  this.$router.push({ name: "customerPublish" });
                } else {
                  this.$message({
                    type: "error",
                    message: "錯誤",
                  });
                }
              })
              .catch((err) => { })
              .then(() => {
                this.submitBtn = false;
              });
          }
        } else {
          this.$message({
            type: "error",
            message: "請填寫必填項",
          });
        }
      });
    },
    GetEventList(ActivityDate, clear) {
      let strarray = [ActivityDate, ActivityDate];
      let params = {
        sgL_ActivityDate: strarray,
        MaxResultCount: 50,
      };
      if (clear) {
        this.albumModel.activeId = "";
      } //清空下拉框数据
      this.$api.EventApi.getEventListBydate(params).then((res) => {
        if (res.data.success) {
          this.activeList = res.data.result.items;
        }
      });
    },
    initMinio() {
      var Minio = require("minio");
      var Client = new Minio.Client({
        endPoint: this.bases.miniIO, //"172.16.3.61", //"218.255.15.93", //"172.16.3.61",//本地，http://60.251.129.78:9000/minio/正式
        port: 9000,
        useSSL: this.bases.miniIOSSL,
        accessKey: "minioadmin",
        secretKey: "minioadmin",
      });
      this.minioClient = Client;
    },
    initMinio2() {
      var Minio = require("minio");
      var Client = new Minio.Client({
        endPoint: this.bases.miniIO, //"172.16.3.61", //"218.255.15.93", //"172.16.3.61",//本地，http://60.251.129.78:9000/minio/正式
        port: 9000,
        useSSL: this.bases.miniIOSSL,
        accessKey: "minioadmin",
        secretKey: "minioadmin",
      });
      return Client;
    },

    compress(base64String, w, quality) {
      var getMimeType = function (urlData) {
        var arr = urlData.split(",");
        var mime = arr[0].match(/:(.*?);/)[1];
        // return mime.replace("image/", "");
        return mime;
      };
      var newImage = new Image();
      var imgWidth, imgHeight;

      var promise = new Promise((resolve) => (newImage.onload = resolve));
      newImage.src = base64String;
      return promise.then(() => {
        imgWidth = newImage.width;
        imgHeight = newImage.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (Math.max(imgWidth, imgHeight) > w) {
          if (imgWidth > imgHeight) {
            canvas.width = w;
            canvas.height = (w * imgHeight) / imgWidth;
          } else {
            canvas.height = w;
            canvas.width = (w * imgWidth) / imgHeight;
          }
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(newImage, 0, 0, canvas.width, canvas.height);
        var base64 = canvas.toDataURL(getMimeType(base64String), quality);
        return base64;
      });
    },
    uploadImage(file, i) {
      let operate = false;
      let stream = require("stream");
      let vm = this;
      let filetype = "";
      switch (file.type) {
        case "image/jpeg":
          filetype = ".jpg";
          break;
        case "image/png":
          filetype = ".png";
          break;
        default:
          vm.$message({
            type: "error",
            message: "請選擇jpg/png格式",
          });
          return;
      }
      let reader = new FileReader();
      reader.readAsDataURL(file);
      return new Promise((resolve) => {
        reader.onloadend = function (e) {
          const dataurl = e.target.result;
          //base64转blob
          const blob = vm.toBlob(dataurl);
          //blob转arrayBuffer
          let reader2 = new FileReader();
          reader2.readAsArrayBuffer(blob);

          reader2.onload = function (ex) {
            //定义流
            let bufferStream = new stream.PassThrough();
            //将buffer写入
            bufferStream.end(new Buffer(ex.target.result));

            let metadata = {
              "content-type": file.type,
              "content-length": file.size,
            };

            var timestamp = uuidv4(); //Date.parse(new Date());

            //上传文件接口]
            var buffer = this.fileBase64;
            vm.UploadTime =  new Date();
            // vm.minioClient = vm.initMinio2();
            vm.minioClient.putObject(
              vm.currentAuthorId + "soonnet",
              vm.buckettime + "/" + file.name,
              bufferStream,
              file.size,
              metadata,
              function (err, etag) {
                //计算速率
                vm.Calculationtime(file["size"]);
                operate = true;
                vm.AlbumInfo.uploadimageName = file.name;
                vm.AlbumInfo.uploadfinsh++;
                let pss = parseInt(
                  (vm.AlbumInfo.uploadfinsh / vm.AlbumInfo.Total) * 100
                );
                pss = pss > 100 ? 100 : pss;
                vm.AlbumInfo.percentage = pss;
                if (vm.AlbumInfo.percentage >= 100) {
                  window.clearInterval(vm.timeData);
                  vm.sendWebSocket();
                }
                var index = vm.imgl.indexOf(file);
                // vm.imgl.remove(file);
                vm.imgl.splice(index, 1);
                if (err) {
                  // console.log("minio upload err", err);
                  resolve(false);
                  return;
                }
                vm.UpdateUploadCallBack(file["size"]);
                resolve(true);
              }
            );
          };
        };
      });
    },
    Calculationtime(size) {
      let successTime = new Date();
      let time = parseInt(successTime - this.UploadTime) / 1000; //完成时间与上传时间差值 S
      this.totalTime += time;
      this.totalSize += (size/1000);
      if ((this.totalSize / this.totalTime * 1.2) > 1024) {
        $("#dangqiansulv").text(
          parseFloat((this.totalSize / this.totalTime / 1024 * 1.2).toFixed(2)) + " MB/s"
        );
      } else {
        $("#dangqiansulv").text(
          parseFloat((this.totalSize / this.totalTime * 1.2).toFixed(2)) + " KB/s"
        );
      }
    },
    //弃用
    fPutObject(file) {
      let _this = this;
      if (file.type != "image/jpeg" && file.type != "image/png") {
        this.$message({
          type: "error",
          message: "請選擇jpg/png的文件",
        });
        return;
      }
      let params = {
        Type: "album",
        id: _this.currentAuthorId,
        data: file,
      };
      _this.$api.albumApi.UploadImage(params).then((res) => {
        if (res.data.success) {
          let imgModel = {};
          imgModel.src = res.data.result.url;
          imgModel.name = res.data.result.uploadName;
          imgModel.time = res.data.result.createTime;
          _this.imgList.push(imgModel);
        }
      });
    },
    bucketExists() {
      let bucket = this.currentAuthorId + "soonnet";
      this.minioClient.bucketExists(bucket).then((err) => {
        if (!err) {
          this.makeBucket();
        } else {
          // this.setPolicy();
          //   console.log(bucket + "已存在");
        }
      });
    },
    //创建桶
    makeBucket() {
      let _this = this;
      let bucket = this.currentAuthorId + "soonnet";
      this.minioClient.makeBucket(bucket, "us-east-1", function (err) {
        if (err) return console.log("创建失败", err);
        _this.setPolicy();
      });
    },
    setPolicy() {
      let bucket = this.currentAuthorId + "soonnet";
      const policy = {
        Version: "2012-10-17",
        Id: "test-policy-1",
        Statement: [
          {
            Action: [
              "s3:GetObject",
              "s3:PutObject",
              "s3:DeleteObject",
              "s3:ListMultipartUploadParts",
              "s3:AbortMultipartUpload",
            ],
            Effect: "Allow",
            Principal: {
              AWS: ["*"],
            },
            Resource: ["arn:aws:s3:::" + bucket + "/*"],
          },
        ],
      };
      this.minioClient.setBucketPolicy(
        bucket,
        JSON.stringify(policy),
        function (err) {
          if (err) throw err;

          console.log("Bucket policy set");
        }
      );
    },
    getPolicy() {
      let bucket = this.currentAuthorId + "soonnet";
      this.minioClient.getBucketPolicy(bucket, function (err, policy) {
        if (err) throw err;

        console.log(`Bucket policy file: ${policy}`);
      });
    },
    timertool() {
      let minutes = 0;
      let seconds = 0;
      let hours = 0;
    },
    beforeupload(file) { },

    fileChange($event) { },

    onchangeupload(file, filelist) { },
    //根据时间排序，后续加进来的相薄排在后面
    compare(prop) {
      return function (obj1, obj2) {
        var val1 = obj1[prop];
        var val2 = obj2[prop];
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      };
    },

    //#region 第三步数据读写
    //读取minio的数据
    getDataList(auto) {
      let _this = this;
      let minioList = [];
      let bucket = this.currentAuthorId + "soonnet";
      var stream = this.minioClient.listObjectsV2(
        bucket,
        this.buckettime,
        true
      );
      stream.on("data", function (obj) {
        let minioModel = {};
        minioModel.src =
          `${_this.bases.imageLoadUrl}` +
          _this.currentAuthorId +
          "soonnet/" +
          obj.name;
        minioModel.name = obj.name.split("/")[1];
        minioModel.time = obj.lastModified;
        minioList.push(minioModel);
      });
      stream.on("end", function () {
        _this.dataList = [];
        //根据时间排序
        minioList.sort(_this.compare("time"));
        minioList.map((res) => {
          if (res.name === "AlbumPoster.jpg") {
            _this.albumModel.imageUrl = res.src;
          } else {
            _this.dataList.push(res);
          }
        });
        _this.pageParams.total = _this.dataList.length;
        _this.pageParams.currentPage = 1;
        if (_this.pageParams.total > 12) {
          _this.pageParams.pageshow = true;
        }
        _this.GetPageData(auto);
      });
      stream.on("error", function (err) {
        console.log(err);
      });
    },
    GetPageData(auto) {
      let SkipCount = (this.pageParams.currentPage - 1) * this.pageParams.limit;
      this.pageData = this.dataList.slice(
        SkipCount,
        SkipCount + this.pageParams.limit
      );
      if (auto) {
        this.createAlbum("albumModel");
      }
    },
    addImage() {
      this.imageCount = 0;
      this.imgList = [];
      this.selectblock = 1;
      this.active = 1;
    },
    //删除minio数据

    deleteMinio(name) {
      let _this = this;

      this.minioClient.removeObject(
        this.currentAuthorId + "soonnet",
        this.buckettime + "/" + name,
        function (err) {
          if (err) {
            return console.log("Unable to remove object", err);
          }

          _this.getDataList();
        }
      );
    },
    deletePhoto(id) {
      let params = {
        Id: id,
      };
      this.$api.albumApi.delphoto(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.getAblumDtl(this.paramsData.id);
        }
      });
    },
    deleteTempMinio() {
      if (this.filenameModel) {
        this.deleteTempLoading = true;
        let _this = this;
        let minioList = [];
        let bucket = this.currentAuthorId + "soonnet";
        var stream = this.minioClient.listObjectsV2(
          bucket,
          this.filenameModel,
          true
        );
        stream.on("data", function (obj) {
          let minioModel = {};
          minioModel.src =
            `${_this.bases.imageLoadUrl}` +
            _this.currentAuthorId +
            "soonnet/" +
            obj.name;
          minioModel.name = obj.name.split("/")[1];
          minioModel.time = obj.lastModified;
          minioList.push(minioModel);
        });
        stream.on("end", function () {
          if (minioList.length > 0) {
            minioList.forEach((item) => {
              _this.minioClient.removeObject(
                bucket,
                _this.filenameModel + "/" + item.name,
                function (err) {
                  if (err) {
                    console.log("Unable to remove object", err);
                  }
                }
              );
            });
            setTimeout(() => {
              _this.getBucketFileList(true);
            }, 2000);
          }
        });
      }
    },
    deleteMinioAll() {
      let _this = this;
      console.log(this.buckettime);
      this.minioClient.removeObject(
        this.currentAuthorId + "soonnet",
        this.buckettime + "/",
        function (err) {
          if (err) {
            return console.log("Unable to remove object", err);
          }
          _this.getDataList();
        }
      );
    },
    //编辑 加载数据
    async getAblumDtl(Id) {
      let params = {
        Id: Id,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
      };
      const res = await this.$api.albumApi.getAlbumDtl(params);
      if (res.data.success) {
        this.albumData = res.data.result;
        this.buckettime = this.albumData.sgL_PG_CResourcesFolder;
        this.photoList = res.data.result.photoGalleryListDtl.items;
        this.pageParams.total = res.data.result.photoGalleryListDtl.totalCount;
        if (this.pageParams.total > 12) {
          this.pageParams.pageshow = true;
        }
        //debugger;
        if (
          this.albumData.sgL_PG_CGameDateF != "" &&
          this.albumData.sgL_PG_CGameDateF != null
        ) {
          this.albumModel.active = "1";
          this.GetEventList(this.albumData.sgL_PG_CGameDateF, false);
        } else {
          this.albumModel.active = "0";
        }
        this.albumModel.keyword = this.albumData.sgL_Keyword;
        this.albumModel.description = this.albumData.sgL_PG_CContent;
        this.albumModel.title = this.albumData.sgL_PG_CName;
        this.albumModel.imageUrl = this.albumData.photoImage;
        this.albumModel.type = this.albumData.sgL_PG_CMasterSort;
        this.albumModel.time = this.albumData.sgL_PG_CShootTimer;
        this.albumModel.set = this.albumData.sgL_PG_CPublicshare;
        this.albumModel.activeId = this.albumData.sgL_PG_CGameID;
        this.albumModel.activeDate = this.albumData.sgL_PG_CGameDateF;
        this.albumModel.EXIF = this.albumData.sgL_PG_CShowExif;
        this.currentAuthorId = this.albumData.sgL_Mem_Cid;
      }
    },
    getNextDate(date, day) {
      var dd = new Date(date);
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    //获取bucket下所有文件夹
    getBucketFileList(load) {
      let List = [];
      let _this = this;
      let bucket = this.currentAuthorId + "soonnet";
      //   let bucket = "mybucket";
      var stream = this.minioClient.listObjects(bucket, "", false);
      stream.on("data", function (obj) {
        if (obj.prefix) {
          List.push(obj.prefix.replace("/", ""));
        }
      });
      stream.on("end", function () {
        $.unique(List); //去重
        //list去除3天前的数据
        let d = new Date(Date.parse(_this.getNowTime(true).replace(/-/g, "/")));
        List = List.filter((c) => _this.format(c) > _this.getNextDate(d, -3));
        if (List.length > 0) {
          _this.$api.albumApi.getUserTempleList({ url: List }).then((res) => {
            if (res.data.result && res.data.result.length > 0) {
              const hideList = res.data.result.map((item) => {
                return item.sgL_PG_CResourcesFolder;
              });
              _this.fileNameList = List.filter(
                (c) => hideList.indexOf(c) === -1
              );
            } else {
              _this.fileNameList = List;
            }
            if (_this.fileNameList.length > 0) {
              _this.dialogFormVisible = true;
            } else {
              _this.dialogFormVisible = false;
            }
          });
        } else {
          _this.fileNameList = List;
        }
        if (load) {
          _this.deleteTempLoading = false;
        }
        if (_this.fileNameList && _this.fileNameList.length === 0) {
          _this.dialogFormVisible = false;
        }
      });
      stream.on("error", function (err) {
        console.log(err);
      });
    },
    //弹出询问框，是否重新上传上次未上传的图片
    Listobj(name) {
      let _this = this;
      let List = [];
      let bucket = this.currentAuthorId + "soonnet";
      //   let bucket = "mybucket";
      var stream = this.minioClient.listObjects(bucket, name, true);

      stream.on("data", function (obj) {
        let imgModel = {};
        imgModel.src =
          `${_this.bases.imageLoadUrl}` +
          _this.currentAuthorId +
          "soonnet/" +
          obj.name;
        imgModel.name = obj.name;
        imgModel.time = obj.lastModified;
        List.push(imgModel);
      });
      stream.on("end", function () {
        List.map((res) => {
          _this.imgList.push(res);
        });
      });
      stream.on("error", function (err) {
        console.log(err);
      });
    },
    //桶集合
    listBuckets() {
      this.minioClient.listBuckets(function (err, buckets) {
        if (err) return console.log(err);
      });
    },

    //#region 一些辅助方法
    sleep(NumMillis) {
      var nowTime = new Date();
      var exitTime = nowTime.getTime() + NumMillis;
      while (true) {
        let now = new Date();
        if (now.getTime() > exitTime) return;
      }
    },
    dateFormat(d) {
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var date = d.getDate();

      let datetime =
        year +
        "-" +
        (month > 9 ? month + "" : "0" + month) +
        "-" +
        (date > 9 ? date + "" : "0" + date);
      return datetime;
    },
    timer() {
      let _this = this;
      var count = 0;
      this.timeData = window.setInterval(function () {
        // var myDate = new Date();
        // let hours = myDate.getHours();
        // let minutes = myDate.getMinutes();
        // let seconds = myDate.getSeconds();

        // var h = _this.checkTime(hours); //获取当前小时数(0-23)
        // var m = _this.checkTime(minutes); //获取当前分钟数(0-59)
        // var s = _this.checkTime(seconds);
        // var timeNow = h + ":" + m + ":" + s;
        // _this.AlbumInfo.usetime = timeNow;

        count++;
        // 需要改变页面上时分秒的值
        _this.AlbumInfo.usetime =
          _this.checkTime(parseInt(count / 60 / 60)) +
          ":" +
          _this.checkTime(parseInt(count / 60) % 60) +
          ":" +
          _this.checkTime(count % 60);
          // console.log("object");
        _this.sendWebSocket();
      }, 1000);
    },
    checkTime(count) {
      if (count < 10) {
        count = "0" + count;
      }
      return count;
    },
    tobase64(file) {
      let imgModel = {};
      imgModel.src = window.URL.createObjectURL(file);
      imgModel.name = file.name;
      imgModel.status = "waitting";
      // imgModel.time = file.lastModified;
      this.imgList.push(imgModel);
      return;
      let _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        let imgModel = {};
        imgModel.src = this.result;
        imgModel.name = file.name;
        imgModel.status = "waitting";
        // imgModel.time = file.lastModified;
        _this.imgList.push(imgModel); //转化为base64用于页面显示
      };
    },
    toBlob(base64Data) {
      let byteString = base64Data;
      if (base64Data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(base64Data.split(",")[1]); // base64 解码
      } else {
        byteString = unescape(base64Data.split(",")[1]);
      }
      // 获取文件类型
      let mimeString = base64Data.split(";")[0].split(":")[1]; // mime类型

      // ArrayBuffer 对象用来表示通用的、固定长度的原始二进制数据缓冲区
      // let arrayBuffer = new ArrayBuffer(byteString.length) // 创建缓冲数组
      // let uintArr = new Uint8Array(arrayBuffer) // 创建视图

      let uintArr = new Uint8Array(byteString.length); // 创建视图

      for (let i = 0; i < byteString.length; i++) {
        uintArr[i] = byteString.charCodeAt(i);
      }
      // 生成blob
      const blob = new Blob([uintArr], {
        type: mimeString,
      });
      // 使用 Blob 创建一个指向类型化数组的URL, URL.createObjectURL是new Blob文件的方法,可以生成一个普通的url,可以直接使用,比如用在img.src上
      return blob;
    },
    //#endregion

    //选择加载minio文件
    submit() {
      this.dialogFormVisible = false;
      this.buckettime = this.filenameModel;
      // this.Listobj(this.buckettime);
      this.active = 3;
      this.selectblock = 3;
      this.getDataList();
    },
    //取消加载minio文件
    cancle() {
      this.dialogFormVisible = false;
    },
    handleAvatarSuccess(res, file) {
      this.uploadId = res.result.uploadId;
      this.albumModel.imageUrl = URL.createObjectURL(file.raw);
    },
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    format(shijianchuo) {
      if (shijianchuo.indexOf("File") > 0) {
        shijianchuo = shijianchuo.replace("File", "");
      }
      //shijianchuo是整数，否则要parseInt转换
      var time = new Date(parseInt(shijianchuo));
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      var str =
        y +
        "-" +
        this.add0(m) +
        "-" +
        this.add0(d) +
        " " +
        this.add0(h) +
        ":" +
        this.add0(mm) +
        ":" +
        this.add0(s);
      return str;
    },
    // beforeAvatarUpload(file) {
    //   const isJPG = file.type === "image/jpeg";
    //   const ispng = file.type === "image/png";
    //   const isLt5M = file.size / 1024 / 1024 < 5;

    //   if (!isJPG && !ispng) {
    //     this.$message.error("上传封面图片只能是 JPG /png格式!");
    //   }
    //   if (!isLt5M) {
    //     this.$message.error("上传封面图片大小不能超过 5MB!");
    //   }
    //   return (isJPG || ispng) && isLt5M;
    // },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      if (this.pageData.length <= 0 && this.photoList.length > 0) {
        this.getAblumDtl(this.albumId);
      } else {
        this.GetPageData();
      }
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      if (this.pageData.length <= 0 && this.photoList.length > 0) {
        this.getAblumDtl(this.albumId);
      } else {
        this.GetPageData();
      }
    },
    changeUpload(file, fileList) {
      /* const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error(`上傳文件大小不能超過 5MB!`);
        return false;
      } */
      switch (file.raw.type) {
        case "image/jpeg":
          break;
        case "image/png":
          break;
        default:
          this.$message({
            message: "請選擇jpg/png格式",
          });
          return;
      }
      this.$refs.cro.initData(file);
      this.$refs.cro.setDialogVisible(true);
    },
    cropperConfirm(img) {
      this.uploadMinioImg(img).then((data) => {
        /* this.this.albumModel.imageUrl = res.data.result.url; */
        this.albumModel.imageUrl =
          this.bases.imageLoadUrl +
          this.customer.userId +
          "soonnet/" +
          this.buckettime +
          "/AlbumPoster.jpg" +
          "?time" +
          uuidv4();
      });
      /*       let formData = new FormData();
      formData.append("file", img, "AlbumPoster.jpg");
      let reqUrl = this.imageUploadUrl + "&id=" + this.currentAuthorId;
      this.$api.albumApi
        .uploadImages(reqUrl, formData)
        .then((res) => {
          if (res.data.success) {
            this.uploadId = res.data.result.uploadId;
            this.albumModel.imageUrl = res.data.result.url;
          }
        })
        .catch((err) => {
          console.log(err);
        }); */
      this.$refs.cro.setDialogVisible(false);
    },
    uploadMinioImg(img) {
      let file = new window.File([img], "AlbumPoster.jpg");
      /*       console.log(1111111111, file, file.size);
      return; */
      //驗證圖片空間
      var network = this.customerModel.sgL_SelfNetworkDisk; //MB
      var disk = parseInt(this.customerModel.sgL_NetworkDiskCapacity) * 1024; //GB
      var thisCountMb = (file.size / 1024 + network).toFixed(2);

      if (thisCountMb >= disk) {
        this.$message({
          type: "error",
          message: "上傳圖片空間不足，請聯繫管理員",
        });
        return;
      }
      if (!this.buckettime || this.buckettime === "") {
        this.$message({
          type: "error",
          message: "上傳文件夾為空，將自動重新加載頁面",
        });
        setTimeout(() => {
          window.location = window.location;
        }, 1500);
        return;
      }
      let reader = new FileReader();
      reader.readAsDataURL(file);
      let vm = this;
      let stream = require("stream");
      return new Promise((resolve) => {
        reader.onloadend = function (e) {
          const dataurl = e.target.result;
          //base64转blob
          const blob = vm.toBlob(dataurl);
          //blob转arrayBuffer
          let reader2 = new FileReader();
          reader2.readAsArrayBuffer(blob);

          reader2.onload = function (ex) {
            //定义流
            let bufferStream = new stream.PassThrough();
            //将buffer写入
            bufferStream.end(new Buffer(ex.target.result));

            let metadata = {
              "content-type": file.type,
              "content-length": file.size,
            };
            vm.minioClient.putObject(
              vm.currentAuthorId + "soonnet",
              vm.buckettime + "/AlbumPoster.jpg",
              bufferStream,
              file.size,
              metadata,
              function (err, etag) {
                resolve(file.name);
              }
            );
          };
        };
      });
    },
    getFileName(url) {
      let pos = url.lastIndexOf("/"); // 查找最后一个/的位置
      return url.substring(pos + 1); // 截取最后一个/位置到字符长度，也就是截取文件名
    },
  },
  beforeDestroy() {
    if (this.timeData != null)
      window.clearInterval(this.timeData);
  },
  computed: {
    getPageShow() {
      return this.pageParams.pageshow;
    },
  },
};
</script>
<style scoped>
.photo-upload>>>.el-upload-dragger {
  width: 100% !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 100%;
  height: 100%;
  display: block;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.album-thumbnail {
  max-width: 178px;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Album/uploadImage.vue